import useEventListener from "@use-it/event-listener";
import { Button } from "antd";
import _ from "lodash";
import moment from "moment";
import React, {
  Fragment,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { addTestResult } from "../../api/addTestResult";
import SoundIcon from "../../assets/icon/soundIcon";
import ViewIcon from "../../assets/icon/viewIcon";
import { getStudentData } from "../../helper/localStorage";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import "./dualNBack1.scss";
import FullScreenLoader from "../../components/fullScreenLoader/fullScreenLoader";

const initialValue = {
  actualStartTime: "",
  activePosition: _.random(0, 3), // initial active position
  activeSound: _.random(0, 22), // initial active alphabet, active alphabet index
  startTime: 0,
  afterActive: false,
  currentTestId: 0,
  isNext: false,

  //position
  posTap: 0,
  posTapTime: 0,
  correctPos: false,
  commissionPos: false,
  omissionPos: true,
  quickPos: false,

  //sound
  soundTap: 0,
  soundTapTime: 0,
  correctSound: false,
  commissionSound: false,
  omissionSound: true,
  quickSound: false,

  // for actual sound start time
  soundStartTime: 0,

  // for value send to result
  posTapped: false,
  soundTappedReducer: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "TEST_STARTED":
      return { ...state, actualStartTime: moment() };

    case "SET_TEST_ID":
      return {
        ...state,
        currentTestId: state.currentTestId + 1,
        correctPos: false,
        commissionPos: false,
        omissionPos: true,
        quickPos: false,
        correctSound: false,
        commissionSound: false,
        omissionSound: true,
        quickSound: false,
        isNext: false,
      };

    case "ACTIVE_POS":
      return { ...state, activePosition: action.payload };

    case "ACTIVE_SOUND":
      return { ...state, activeSound: action.payload };

    case "START_TIME":
      return { ...state, startTime: moment() };

    // for value send to result

    case "TOGGLE_TAPPED":
      return { ...state, ...action.payload };

    //position
    case "POS_TAP":
      return { ...state, posTap: state.posTap + 1 };

    case "POS_TAP_TIME":
      return { ...state, posTapTime: action.payload };

    case "QUICK_TAP_POS":
      return { ...state, quickPos: true, omissionPos: false };

    case "CORRECT_TAP_POS":
      return { ...state, correctPos: true, omissionPos: false };

    case "INCORRECT_TAP_POS":
      return { ...state, commissionPos: true, omissionPos: false };

    //sound

    // for actual sound start time
    case "SOUND_START_TIME":
      return { ...state, soundStartTime: action.payload };

    case "SOUND_TAP":
      return { ...state, soundTap: state.soundTap + 1 };

    case "SOUND_TAP_TIME":
      return { ...state, soundTapTime: action.payload };

    case "QUICK_TAP_SOUND":
      return { ...state, quickSound: true, omissionSound: false };

    case "CORRECT_TAP_SOUND":
      return { ...state, correctSound: true, omissionSound: false };

    case "INCORRECT_TAP_SOUND":
      return { ...state, commissionSound: true, omissionSound: false };

    case "MOVE_TO_NEXT":
      return { ...state, isNext: true };

    case "AFTER_ACTIVE":
      return { ...state, afterActive: true }; // after que disappear in 250ms

    case "RESET":
      return { ...initialValue };

    default:
      return state;
  }
};

// removing vowels from sound array
const soundArray = [
  // "a",
  "c",
  // "e",
  "f",
  "g",
  "h",
  // "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  // "o",
  "p",
  "q",
  "r",
  "s",
  // "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export default function DualNBack1({ questions: calQues, index: calIndex }) {
  console.log("calQues", calQues);

  const randTime = _.random(20, 31) * 100;
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const [dualNBack, dispatchDnB] = useReducer(reducer, initialValue);
  // const [questions, setQuestions] = useState(getQuesArray(helperC.testType));
  const [questions, setQuestions] = useState(() =>
    getQuesArray(helperC.testType)
  );
  const [audioPlayFlag, setAudioPlayFlag] = useState(0);

  const nextClickRef = useRef(null);
  const positionTapRef = useRef(null);
  const soundTapRef = useRef(null);

  let {
    activePosition,
    activeSound,
    currentTestId,
    isNext,
    startTime,

    //sound
    correctSound,
    commissionSound,
    omissionSound,
    quickSound,
    soundTap,
    posTapTime,

    //position
    correctPos,
    commissionPos,
    omissionPos,
    quickPos,
    posTap,
    soundTapTime,

    // for actual sound start time
    soundStartTime,

    // for value send to result
    posTapped,
    soundTappedReducer,
  } = dualNBack;

  useEffect(() => {
    soundArray.forEach((sound) => {
      const myAudio = new Audio();
      myAudio.src =
        require(`../../assets/audio/dual_n-back1/${sound}_sound.mp3`);
    });

    const actualRandomTime = randTime;
    // 15 june 2021 because getting these random time value for sound and pos tap
    // dispatchDnB({ type: "POS_TAP_TIME", payload: actualRandomTime });
    // dispatchDnB({ type: "SOUND_TAP_TIME", payload: actualRandomTime });
    // this block gave the start to move question forward
    dispatchDnB({ type: "POS_TAP_TIME", payload: 1500 });
    dispatchDnB({ type: "SOUND_TAP_TIME", payload: 1500 });
    const timeout = setTimeout(
      () => {
        dispatchDnB({ type: "MOVE_TO_NEXT" });
      },
      // 1000
      actualRandomTime
    );
    return () => {
      clearTimeout(timeout);
      console.log("dualNBack1.jsx useEffect clean up");
    };
  }, []);

  const handleNextQues = (question, index) => {
    //active sound and position changing after
    if (question.pos === "1") {
      console.log(index, "position if 1");
      dispatchDnB({ type: "ACTIVE_POS", payload: activePosition });
    } else {
      console.log(index, "position if 0");
      dispatchDnB({
        type: "ACTIVE_POS",
        payload: getRandomPos(activePosition),
      });
    }
    // for sound
    if (question.sound === "1") {
      console.log(index, "sound if 1");
      dispatchDnB({ type: "ACTIVE_SOUND", payload: activeSound });
    } else {
      console.log(index, "sound if 0");
      dispatchDnB({
        type: "ACTIVE_SOUND",
        payload: getActiveSound(activeSound),
      });
    }
  };

  const [tapped, setTapped] = useState(true);
  const [soundTapped, setSoundTapped] = useState(true);

  // virtually clicked to move forward
  const handleNext = (question, index, prevPos, prevSound) => {
    setAudioPlayFlag(0);
    dispatchDnB({ type: "SET_TEST_ID" });
    dispatchDnB({ type: "START_TIME" });
    let noTapCorrectPos = false;
    let noTapCorrectSound = false;

    //no tap correct logic
    if (prevPos === "0") {
      noTapCorrectPos = !correctPos && omissionPos;
    }
    if (prevSound === "0") {
      noTapCorrectSound = !correctSound && omissionSound;
    }

    let posValue = handlePos(
      noTapCorrectPos,
      correctPos,
      quickPos,
      omissionPos,
      commissionPos,
      index
    );

    let soundValue = handleSound(
      noTapCorrectSound,
      correctSound,
      quickSound,
      omissionSound,
      commissionSound,
      index
    );

    console.log(
      "posTapTime,soundTapTime, sound",
      posTapTime,
      soundTapTime,
      soundArray[activeSound]
    );

    const getAnswerValue = () => {
      return {
        position: {
          ...posValue,
          // timeSpend: posTapTime,
          timeSpend: posTapped ? posTapTime : 1500,
          noTapCorrectPos,
          correctPos,
          quickPos,
          omissionPos: noTapCorrectPos || correctPos ? false : omissionPos,
          commissionPos,
          posTap,
        },

        sound: {
          ...soundValue,
          // timeSpend: soundTapTime,
          timeSpend: soundTappedReducer ? soundTapTime : 1500,
          noTapCorrectSound,
          correctSound,
          quickSound,
          omissionSound:
            noTapCorrectSound || correctSound ? false : omissionSound,
          commissionSound,
          soundTap,
        },
      };
    };

    if (index > 0)
      //collecting answer
      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: getAnswerValue(),
      });

    if (questions.length - 1 > index) {
      const actualRandomTime = randTime;

      // setTimeout(() => {
      //   setTapped(false);
      // }, actualRandomTime - 250);

      handleNextQues(question, index);
      setTimeout(
        () => {
          // 15 june 2021 because getting these random time value for sound and pos tap
          // dispatchDnB({ type: "POS_TAP_TIME", payload: actualRandomTime });
          // dispatchDnB({ type: "SOUND_TAP_TIME", payload: actualRandomTime });
          dispatchDnB({ type: "MOVE_TO_NEXT" });
          dispatchDnB({
            type: "TOGGLE_TAPPED",
            payload: { soundTappedReducer: false, posTapped: false },
          });
          setTapped(true);
        },
        // 1000
        actualRandomTime
      );
    } else {
      // onSubmit for calibration

      let res = [];
      let answerForSummary = {};
      const myFullAnswer = [...answerC.answers, getAnswerValue()];

      let totalScore = 0;
      let averageTimeSpend = 0;
      let totalTimeSpend = 0;
      //Position
      let corPos = 0;
      let inCorPos = 0;
      let omiPos = 0;
      let commPos = 0;
      let quickTapPos = 0;
      let timeSpendPos = 0;
      //sound
      let corSound = 0;
      let inCorSound = 0;
      let omiSound = 0;
      let commSound = 0;
      let quickTapSound = 0;
      let timeSpendSound = 0;

      myFullAnswer.forEach((answer) => {
        if (answer.position.correctPos || answer.position.noTapCorrectPos) {
          corPos = corPos + 1;
        } else {
          inCorPos = inCorPos + 1;
        }

        if (answer.position.answer_flag === "Omission") {
          omiPos = omiPos + 1;
        }

        if (answer.position.answer_flag === "Commission") {
          commPos = commPos + 1;
        }

        if (answer.position.quickPos) {
          quickTapPos = quickTapPos + 1;
        }

        //sound
        if (answer.sound.correctSound || answer.sound.noTapCorrectSound) {
          corSound = corSound + 1;
        } else {
          inCorSound = inCorSound + 1;
        }
        if (answer.sound.answer_flag === "Omission") {
          omiSound = omiSound + 1;
        }

        if (answer.sound.answer_flag === "Commission") {
          commSound = commSound + 1;
        }

        if (answer.sound.quickSound) {
          quickTapSound = quickTapSound + 1;
        }
        if (answer.sound.timeSpend) {
        }

        timeSpendPos = timeSpendPos + parseInt(answer.position.timeSpend);
        timeSpendSound = timeSpendSound + parseInt(answer.sound.timeSpend);

        totalTimeSpend = timeSpendPos + timeSpendSound;

        // answer length with position and sound
        const answerLWithPS = answerC.answers.length * 2;
        averageTimeSpend = totalTimeSpend / answerLWithPS;

        const totalCorrect = corSound + corPos;
        const totalIncorrect = inCorPos + inCorSound;
        const totalQuickTap = quickTapPos + quickTapSound;

        totalScore = totalCorrect - totalIncorrect + 100;
        console.log("totalScore", totalScore);
        const totalComm = commSound + commPos;

        if (totalComm > 4 && totalQuickTap > 6) {
          let tapToLess = totalQuickTap - 6;
          totalScore = totalScore - tapToLess;
          totalScore = totalScore / 2;
        } else {
          totalScore = totalScore / 2;
        }

        totalScore = Math.sign(totalScore) === -1 ? 0 : Math.floor(totalScore);

        res = [...res, answer.position, answer.sound];
        answerForSummary = {
          totalScore,
          averageTimeSpend,
          totalTimeSpend,
          //pos
          corPos,
          inCorPos,
          omiPos,
          commPos,
          quickTapPos,
          timeSpendPos,
          posTap,
          //sound
          corSound,
          inCorSound,
          omiSound,
          commSound,
          quickTapSound,
          timeSpendSound,
          soundTap,
        };
      });

      const answerResForApi = res.map((myRes, index) => {
        return {
          answer: myRes.answer,
          que_flag: myRes.que_flag,
          que_id: index + 1,
          file_encoded: "",
          file_path: "",
          file_type: "",
          json_res: "",
          que_score: myRes.que_score,
          que_time: myRes.timeSpend,
          answer_flag: myRes.answer_flag,
        };
      });

      const grade_id = JSON.parse(localStorage.getItem("gradeId"));
      const { login_id } = getStudentData();
      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerResForApi,
        player_image: "",
        player_time: totalTimeSpend,
        total_tap: soundTap + posTap,
        total_tap_s: soundTap,
        total_tap_p: posTap,
        player_score: Math.sign(totalScore) === -1 ? 0 : totalScore,
        test_id: 190425225046,
      };
      // for summary we don't need previous answer data
      dispatchAnswer({
        type: "RESET_ANSWER",
      });

      // record answer to show summary of dnb
      if (helperC.testType === "CALIBRATION") {
        res.forEach((myRes, index) => {
          const answerForCalSummary = {
            answer: myRes.answer,
            que_id: index + 1,
            file_encoded: "",
            file_path: "",
            file_type: "",
            json_res: "",
            que_score: myRes.que_score,
            que_time: myRes.timeSpend,
            answer_flag: myRes.answer_flag,
            section_name: calQues[0].section_name,
          };
          dispatchAnswer({ type: "ADD_ANSWER", payload: answerForCalSummary });
        });
      } else {
        dispatchAnswer({ type: "ADD_ANSWER", payload: answerForSummary });
      }

      // if Test is calibration test
      if (helperC.testType === "CALIBRATION") {
        const nexQuesId = calQues[calIndex + 1].id;
        dispatchHelper({
          type: "RUNNING_QUES_ID",
          payload: nexQuesId,
        });
      } else {
        addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      }
    }
  };

  useEffect(() => {
    if (isNext) {
      nextClickRef && nextClickRef.current.click();
    }
  }, [isNext]);

  console.log(posTap);
  console.log(soundTap);

  // on position click
  const handlePosCheck = (prevPos) => {
    setTapped(true);

    const tapTimer = setTimeout(() => {
      setTapped(false);
      clearTimeout(tapTimer);
    }, 250);

    const tapTimePos = moment().diff(startTime);

    console.log("timeTaken for position tap tapTimePos", tapTimePos);

    dispatchDnB({ type: "POS_TAP" });
    dispatchDnB({ type: "POS_TAP_TIME", payload: tapTimePos });
    dispatchDnB({
      type: "TOGGLE_TAPPED",
      payload: { posTapped: true },
    });

    if (prevPos) {
      if (prevPos !== "1") {
        dispatchDnB({ type: "INCORRECT_TAP_POS" });
      } else {
        dispatchDnB({ type: "CORRECT_TAP_POS" });
        if (tapTimePos < 300) {
          dispatchDnB({ type: "QUICK_TAP_POS" });
        }
      }
    } else {
      return;
    }
  };

  // on sound click
  const handleSoundCheck = (prevSound) => {
    setSoundTapped(true);
    const tapTimer = setTimeout(() => {
      setSoundTapped(false);
      clearTimeout(tapTimer);
    }, 250);
    const tapTimeSound = moment().diff(startTime);

    const tapTimeSoundAudioPlayed = moment().diff(soundStartTime);

    console.log(
      "timeTaken for sound tap tapTimeSound, tapTimeSoundAudioPlayed : ",
      tapTimeSound,
      tapTimeSoundAudioPlayed
    );

    dispatchDnB({ type: "SOUND_TAP" });
    dispatchDnB({ type: "SOUND_TAP_TIME", payload: tapTimeSound });
    dispatchDnB({
      type: "TOGGLE_TAPPED",
      payload: { soundTappedReducer: true },
    });

    if (prevSound) {
      if (prevSound !== "1") {
        //dispatchDnB({ type: "CORRECT_TAP_SOUND" });
        dispatchDnB({ type: "INCORRECT_TAP_SOUND" });
      } else {
        //dispatchDnB({ type: "INCORRECT_TAP_SOUND" });
        dispatchDnB({ type: "CORRECT_TAP_SOUND" });
        if (tapTimeSound < 300) {
          dispatchDnB({ type: "QUICK_TAP_SOUND" });
        }
      }
    } else {
      console.log("first question");
    }
  };

  useEffect(() => {
    console.log(
      "%c ------ index",
      "color:red;font-size:1rem;font-weight:bold",
      currentTestId
    );
    console.log(
      "%c ------ Sound",
      "color:green;font-size:1rem;font-weight:bold"
    );

    console.log("%c correctSound", "color:green;font-size:1rem;", correctSound);
    console.log(
      "%c commissionSound",
      "color:green;font-size:1rem;",
      commissionSound
    );
    console.log(
      "%c omissionSound",
      "color:green;font-size:1rem;",
      omissionSound
    );
    console.log("%c quickSound", "color:green;font-size:1rem;", quickSound);

    console.log(
      "%c ------ position",
      "color:blue;font-size:1rem;font-weight:bold"
    );
    console.log(
      "%c correctPos",
      "color:blue;font-size:1rem;font-weight:bold",
      correctPos
    );
    console.log(
      "%c commissionPos",
      "color:blue;font-size:1rem;font-weight:bold",
      commissionPos
    );
    console.log(
      "%c omissionPos",
      "color:blue;font-size:1rem;font-weight:bold",
      omissionPos
    );
    console.log(
      "%c quickPos",
      "color:blue;font-size:1rem;font-weight:bold",
      quickPos
    );
  }, [
    commissionPos,
    commissionSound,
    correctPos,
    correctSound,
    currentTestId,
    omissionPos,
    omissionSound,
    quickPos,
    quickSound,
  ]);

  // key tap click
  const POSITIONS_KEY = ["65", "a", "A"];
  function positionKeyHandler({ key }) {
    if (POSITIONS_KEY.includes(String(key))) {
      positionTapRef.current && positionTapRef.current.click();
    }
  }
  const SOUND_KEY = ["76", "l", "L"];
  function soundKeyHandler({ key }) {
    if (SOUND_KEY.includes(String(key))) {
      soundTapRef.current && soundTapRef.current.click();
    }
  }
  useEventListener("keyup", soundKeyHandler);
  useEventListener("keyup", positionKeyHandler);

  const handlePlayAudio = (sound) => {
    // soundArray
    console.log(" AUdio rendered", sound);
    let myAudio = new Audio();
    myAudio.src =
      require(`../../assets/audio/dual_n-back1/${sound}_sound.mp3`);
    setTimeout(() => {
      myAudio.play();
      dispatchDnB({ type: "SOUND_START_TIME", payload: moment() });
    }, 250);

    // myAudio.play();

    setAudioPlayFlag(1);
  };

  return (
    <>
      {answerC.isLoading && <FullScreenLoader />}
      <div className="dnb-test">
        {/* <p className="">Question</p> */}
        {!answerC.isLoading && <p className="">Question</p>}
        {questions.map((question, quesIndex) => {
          return (
            <Fragment key={quesIndex}>
              {currentTestId === quesIndex && (
                <>
                  <div className="appear-screen-area">
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((pos) => {
                      return (
                        <div
                          key={pos}
                          className={`appear-screen ${
                            activePosition === pos && "active"
                          }`}
                        ></div>
                      );
                    })}
                  </div>
                  {soundArray.map((sound, index) => {
                    return (
                      <Fragment key={index}>
                        {audioPlayFlag === 0 && (
                          <>
                            {index === activeSound && (
                              <>{handlePlayAudio(sound)}</>
                            )}
                          </>
                        )}
                      </Fragment>
                    );
                  })}
                  <div className="dndBtns">
                    <div className="dnb-btn-blk">
                      <p>
                        Press below tab or key <span>A</span> for the same
                        position
                      </p>
                      <button
                        ref={positionTapRef}
                        className={`dndBtn1 ${
                          !omissionPos && tapped && "tapped" //omission false mean button is tapped
                          //tapped variable set for disappearing 250ms before next question
                        }`}
                        onClick={() =>
                          handlePosCheck(
                            quesIndex > 0 && questions[quesIndex - 1].pos
                          )
                        }
                      >
                        {/* omissionPos only trigger when button tapped */}
                        <ViewIcon />
                      </button>
                    </div>

                    <div className="dnb-btn-blk">
                      <p>
                        Press below tab or key <span>L</span> for the same sound
                      </p>
                      <button
                        ref={soundTapRef}
                        className={`dndBtn2 ${
                          !omissionSound && soundTapped && "tapped" //omission false mean button is tapped
                          //tapped variable set for disappearing 250ms before next question
                        }`}
                        onClick={() =>
                          handleSoundCheck(
                            quesIndex > 0 && questions[quesIndex - 1].sound
                          )
                        }
                      >
                        {/* omissionPos only trigger when button tapped */}
                        {!omissionSound && tapped ? (
                          <SoundIcon />
                        ) : (
                          <SoundIcon />
                        )}
                      </button>
                    </div>
                  </div>
                  <Button
                    style={{ display: "none" }}
                    ref={nextClickRef}
                    onClick={() =>
                      handleNext(
                        question,
                        quesIndex,
                        quesIndex > 0 && questions[quesIndex - 1].pos,
                        quesIndex > 0 && questions[quesIndex - 1].sound
                      )
                    }
                  >
                    next
                  </Button>
                </>
              )}
            </Fragment>
          );
        })}
      </div>
    </>
  );
}

const handleAudioPlay = (sound) => {
  console.log(`${sound}_sound.mp3`);
  // const alphabet = new Audio(
  //   `../../assets/audio/dual_n-back1/${sound}_sound.mp3`
  // );
  // alphabet.play();
};

const handlePos = (noTapCorrect, correct, quick, omission, commission, id) => {
  console.log("pos", correct, quick, omission, commission, id);
  const answer_flag =
    omission && !noTapCorrect
      ? "Omission"
      : commission
      ? "Commission"
      : quick
      ? "Quick Tap"
      : "";
  // const que_score = quick ? 0 : correct ? 1 : noTapCorrect ? 1 : -1;
  const que_score = quick ? 1 : correct ? 1 : noTapCorrect ? 1 : -1;
  //const answer = quick ? "N" : correct ? "P" : noTapCorrect ? "N" : "N";
  const answer = quick
    ? "Y"
    : correct
    ? "P"
    : noTapCorrect
    ? "N"
    : commission
    ? "P"
    : "N";

  const value = {
    answer_flag,
    answer,
    que_score,
    que_id: id,
    que_flag: "P",
  };

  return value;
};

const handleSound = (
  noTapCorrect,
  correct,
  quick,
  omission,
  commission,
  id
) => {
  console.log("sound", correct, quick, omission, commission, id);

  const answer_flag =
    omission && !noTapCorrect
      ? "Omission"
      : commission
      ? "Commission"
      : quick
      ? "Quick Tap"
      : "";
  //const que_score = quick ? 0 : correct ? 1 : noTapCorrect ? 1 : -1;
  const que_score = quick ? 1 : correct ? 1 : noTapCorrect ? 1 : -1;
  //const answer = quick ? "N" : correct ? "S" : noTapCorrect ? "N" : "N";
  //const answer = quick ? "Y" : correct ? "S" : noTapCorrect ? "N" : "N";
  const answer = quick
    ? "Y"
    : correct
    ? "S"
    : noTapCorrect
    ? "N"
    : commission
    ? "S"
    : "N";

  const value = {
    answer_flag,
    answer,
    que_score,
    que_id: id,
    que_flag: "S",
  };
  return value;
};

const getRandomPos = (prev) => {
  let posi = _.random(0, 8);
  console.log("prev---position--->", prev);
  // position should not at position 4 and prev position
  while (posi === 4 || prev === posi) {
    posi = _.random(0, 8);
  }
  return posi;
};

const getActiveSound = (prev) => {
  console.log("prev---sound--->", prev);
  // let sound = _.random(0, 22);

  // for removing vowels
  let sound = _.random(0, 17);
  while (sound === prev) {
    // sound = _.random(0, 22);
    sound = _.random(0, 17);
  }
  // console.log("random sound", sound);
  return sound;
};

const getQuesArray = (testType) => {
  let pos =
    testType === "DEMO" || testType === "CALIBRATION"
      ? ["1", "0", "1", "0", "1", "0", "1", "0", "1", "0", "1"]
      : [
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
        ];
  let sound =
    testType === "DEMO" || testType === "CALIBRATION"
      ? ["1", "0", "1", "0", "1", "0", "1", "0", "1", "0", "1"]
      : [
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
          "0",
          "1",
        ];

  //FIXME
  // pos = ["0", "1", "1", "0", "1", "0"];
  // sound = ["0", "1", "0", "1", "1", "1"];

  // pos = ["0", "1"];
  // sound = ["0", "1"];

  pos = _.shuffle(pos);
  sound = _.shuffle(sound);

  console.log("testing dnb sound length", sound.length);
  console.log("testing dnb soundArray length", soundArray.length);

  const compList = pos.map((value, index) => {
    return {
      pos: value,
      sound: sound[index],
    };
  });
  return compList;
};
